// This file is to slowly transition the api.js file over to typescript
// Just not to do it all at once
import requester from './requester';
import {
  ACCEPT_APPLICATION_SHARE,
  DECLINE_APPLICATION_SHARE,
  GET_ADDRESS_AUTOCOMPLETE,
  GET_ADDRESS_DETAILS,
  GET_GOOGLE_MAPS_SIGNED_URL,
  GET_LISTING_EXISTS_IN_LISTING_HUB,
  GET_PROPERTIES,
  GET_SHARED_APPLICATION,
} from '../constants/endpoints';
import type {
  AddressesResponse,
  GoogleMapsSignedUrl,
  PropertiesListResponse,
  PropertyDetailsResponse,
  RentalManagerResponseType,
  ShareApplicationPropertyAddress,
  ShareApplicationPropertyAddressResponse,
} from '../models';
import type { AcceptShareResponse, DeclineShareResponse } from '../models/shareResponse';

export const getSharedApplication = (shareId: string) => {
  return requester<RentalManagerResponseType<ShareApplicationPropertyAddressResponse>>({
    method: 'GET',
    path: GET_SHARED_APPLICATION,
    params: { shareId },
  });
};

export const getAddressDetails = (fullAddress: string) => {
  return requester<RentalManagerResponseType<PropertyDetailsResponse>>({
    method: 'GET',
    path: GET_ADDRESS_DETAILS,
    params: { fullAddress },
  });
};

export const getGoogleMapsSignUrl = (url: string) => {
  return requester<GoogleMapsSignedUrl>({
    method: 'POST',
    path: GET_GOOGLE_MAPS_SIGNED_URL,
    body: { url },
    params: { brandName: 'zillow' },
  });
};

export const getListingExistsInListingHub = (listingAlias: string) => {
  return requester<RentalManagerResponseType<boolean>>({
    method: 'GET',
    path: GET_LISTING_EXISTS_IN_LISTING_HUB,
    params: { listingAlias },
  });
};

export const acceptRentalApplicationShare = ({ listingAlias, shareId }: { listingAlias: string; shareId: string }) => {
  return requester<RentalManagerResponseType<AcceptShareResponse>>({
    method: 'POST',
    path: ACCEPT_APPLICATION_SHARE,
    body: { listingAlias, shareId },
  });
};

export const declineRentalApplicationShare = ({
  shareId,
  message,
  updatedAddress,
}: {
  shareId: string;
  message: string;
  updatedAddress: ShareApplicationPropertyAddress;
}) => {
  return requester<RentalManagerResponseType<DeclineShareResponse>>({
    method: 'POST',
    path: DECLINE_APPLICATION_SHARE,
    body: {
      shareId,
      declineReason: 'INCORRECT_ADDRESS',
      message,
      additionalInfo: {
        updatedAddress,
      },
    },
  });
};

export const getAddressAutocomplete = (params: { partialAddress: string }) => {
  return requester<RentalManagerResponseType<AddressesResponse>>({
    method: 'GET',
    path: GET_ADDRESS_AUTOCOMPLETE,
    params,
  });
};

export const getProperties = () => {
  return requester<RentalManagerResponseType<PropertiesListResponse>>({
    method: 'GET',
    path: GET_PROPERTIES,
  });
};
